function EastTimor({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1099)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M15.9999 0C12.0826 0 8.49475 1.40856 5.71338 3.74587L22.9564 16L5.71338 28.2541C8.49475 30.5914 12.0826 32 15.9999 32C24.8364 32 31.9999 24.8365 31.9999 16C31.9999 7.1635 24.8364 0 15.9999 0Z" fill="#D80027"/>
  <path d="M4.68628 4.68555C-1.56209 10.9339 -1.56209 21.0646 4.68628 27.313C7.26834 24.731 9.75165 22.2477 16 15.9993L4.68628 4.68555Z" fill="black"/>
  <path d="M4.43623 12.334L6.87123 14.6385L9.81548 13.0345L8.37642 16.0626L10.8115 18.3672L7.48686 17.9342L6.04761 20.9622L5.43217 17.6665L2.10754 17.2334L5.05167 15.6295L4.43623 12.334Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default EastTimor;
